import { AvatarFontSizeVariants, AvatarSizeVariants, AvatarSizeVariantsStyles } from 'constants/common';
import { cn } from 'utils/global';

import Skeleton from './skeleton/Skeleton';

export const COMMON_AVATAR_CLASSNAME = 'w-8 h-8 rounded-full';

interface Props {
  isLoading?: boolean;
  imagePath?: string | null;
  className?: string;
  size?: AvatarSizeVariants;
  firstName?: string;
  lastName?: string;
  email?: string;
  iconWithText?: boolean;
  iconWithTextAndEmail?: boolean;
}

const getInitials = (firstName?: string, lastName?: string): string => {
  const firstInitial = firstName?.charAt(0) ?? '';
  const lastInitial = lastName?.charAt(0) ?? '';
  return `${firstInitial}${lastInitial}`.toUpperCase();
};

const Avatar = ({
  imagePath,
  isLoading,
  className,
  size = AvatarSizeVariants.MD,
  firstName,
  lastName,
  email,
  iconWithText,
  iconWithTextAndEmail,
}: Props) => {
  if (isLoading) {
    return <Skeleton className={cn(COMMON_AVATAR_CLASSNAME, className)} />;
  }

  if (!imagePath) {
    return (
      <div className={cn('flex items-center')}>
        <div
          className={cn(
            COMMON_AVATAR_CLASSNAME,
            'flex items-center justify-center bg-primary-600 text-white font-medium text-sm uppercase',
            className,
            AvatarSizeVariantsStyles[size],
            AvatarFontSizeVariants[size]
          )}
        >
          {getInitials(firstName, lastName)}
        </div>
        {iconWithText && (
          <span className={cn('ml-2 !text-bodyMd text-neutral-700 dark:text-neutral-300')}>
            {firstName} {lastName}
          </span>
        )}
        {iconWithTextAndEmail && (
          <div className="ml-2 flex flex-col">
            <span className={cn('text-sm text-neutral-900 dark:text-neutral-100')}>
              {firstName} {lastName}
            </span>
            <span className={cn('!text-bodySm text-neutral-600 dark:text-neutral-400')}>{email}</span>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={cn('flex items-center')}>
      <img
        className={cn(COMMON_AVATAR_CLASSNAME, className, AvatarSizeVariantsStyles[size])}
        src={imagePath}
        alt="userImage"
      />
      {iconWithText && (
        <span className={cn('ml-2 !text-bodyMd text-neutral-700 dark:text-neutral-300')}>
          {firstName} {lastName}
        </span>
      )}
      {iconWithTextAndEmail && (
        <div className="ml-2 flex flex-col">
          <span className={cn('text-sm text-neutral-900 dark:text-neutral-100')}>
            {firstName} {lastName}
          </span>
          <span className={cn('!text-bodySm text-neutral-600 dark:text-neutral-400')}>{email}</span>
        </div>
      )}
    </div>
  );
};

export default Avatar;
